module.exports = __webpack_public_path__ + "static/media/person2.3eb201aa.jpg";